import React from 'react';
import { navigate } from 'gatsby';
import { chakra, Slide, Button } from '@chakra-ui/react';
import { useLocalStorage } from '../../hooks/useLocalStorage';

const FixedBar = chakra('div', {
  baseStyle: {
    position: 'relative',
    left: '0',
    top: '0',
    width: '100%',
    textAlign: 'left',
    padding: '16px',
    boxShadow: '0 -1px 7px rgba(0, 0, 0, 0.12)',
    background: '#25404e',
    fontSize: '13px',
    color: '#fff',
    a: {
      color: '#fff',
      textDecoration: 'underline',
    },
    button: {
      fontSize: '14px !important',
    },
  },
});

type Props = {
  /** Is the Datosms ID for the current page */
  originalId?: string;
  itemTypes?: string;
};

/** Shows A bar at the top of the website to allow editing of pages linked to the CMS and also allows switching between the US and NZ versions of the website . */
const AdminBar = ({ originalId, itemTypes }: Props): JSX.Element => {
  const [showAdminBar, setShowAdminBar] = useLocalStorage('showAdminBar');
  const [locale, setLocale] = useLocalStorage('browserLocation');

  if (showAdminBar) {
    return (
      <Slide direction="top" in={showAdminBar} style={{ zIndex: 10 }}>
        <FixedBar>
          <div>
            {originalId ? (
              <a
                href={`https://saferme.admin.datocms.com/editor/item_types/${itemTypes}/items/${originalId}/edit`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="adminBarButton">Edit page</Button>
              </a>
            ) : (
              <span style={{ fontSize: '14px', marginRight: '2rem' }}>
                This page can't be edited in DatoCMS. Please contact the web
                admin.
              </span>
            )}

            {locale === 'en-NZ' ? (
              <Button
                display={['block', 'inline-block']}
                textAlign="right"
                mr="spaces.5"
                p="spaces.0"
                bg="transparent"
                onClick={() => {
                  setLocale('en');
                  navigate('/');
                }}
              >
                Go to US site
              </Button>
            ) : (
              <Button
                display={['block', 'inline-block']}
                textAlign="right"
                mr="8"
                p="0"
                bg="transparent"
                onClick={() => {
                  setLocale('en-NZ');
                  navigate('/en-nz/');
                }}
              >
                Go to NZ site
              </Button>
            )}

            <Button
              display={['block', 'inline-block']}
              textAlign="right"
              p="spaces.0"
              bg="transparent"
              onClick={() => {
                setShowAdminBar(false);

                // This saves the fact the user has seen and accepted the cookie warning to local storage. We will check if the user has this value on page loaf via the layout component to make sure it does not get shown again
                localStorage.setItem('showAdminBar', 'false');
              }}
            >
              Hide admin bar
            </Button>
          </div>
        </FixedBar>
      </Slide>
    );
  }
  return null;
};

export default AdminBar;
